import { createSelector } from 'reselect'

const getHeroBannerData = (state) => state?.heroBanner?.data

export const getHeroBanners = createSelector(
  [getHeroBannerData],
  (data) => {
    if (!data) return []

    if (Array.isArray(data)) return data
    if (data.data && Array.isArray(data.data)) return data.data
    if (typeof data === 'object' && Object.keys(data).length > 0) return [data]

    return []
  }
)

export const isLoading = (state) => state?.heroBanner?.isLoading || false

export const getError = (state) => state?.heroBanner?.error || null
